import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { layoutAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import { areMatchesLoaded, resetMatchesLoaded, loadMatches } from '../reducers/dailyMatches';
import { filterMatchesByState } from 'modules/Football/utils';
import { userServiceLayoutConnect } from 'modules/Common/reducers/userService';
import FootballLiveCompetitionList from '../components/FootballLiveCompetitionList';
import FootballMyScores from "./FootballMyScores";
import Tabs from 'modules/Common/components/Tabs';

import { LIVE_REFRESH_INTERVAL_MILLIS, MATCH_FILTER_EMPTY_MESSAGE } from 'modules/Football/consts';

@layoutAsyncConnect(
  'FootballLiveHomeTabs',
  [
    {
      dispatch: () => loadMatches(),
      refreshInterval: LIVE_REFRESH_INTERVAL_MILLIS,
      preventResolve: ({ state, params: { date } }) => areMatchesLoaded(state, date),
      state: state => ({ matches: state.football.dailyMatches.matches }),
      preserveRefresh: true,
      reset: () => resetMatchesLoaded()
    },
    userServiceLayoutConnect()
  ]
)
@catchLifeCycleErrors
export default class FootballLiveHomeTabs extends Component {

  static propTypes = {
    matches: PropTypes.array.isRequired,
    location: PropTypes.object.isRequired,
  };

  getFilter = (currentLocation) => {
    if (currentLocation.endsWith('ongoing')) { return 'ongoing' }
    if (currentLocation.endsWith('up-next')) { return 'upNext' }
    if (currentLocation.endsWith('finished')) { return 'finished' }
    return 'all'
  };

  render() {
    const {matches = [], location} = this.props;
    const filter = this.getFilter(location.pathname);

    const liveMatchCount = filterMatchesByState(matches, 'ongoing').length;
    const filteredMatches = filterMatchesByState(matches, filter);

    return (
      <div className="footballLiveHomeTabbed">
        <Tabs tabs={[
          {
            href: "/football/live",
            text: "All",
            isIndex: true,
            className: "allTab"
          }, {
            href: "/football/live/filter/ongoing",
            text: `Live${liveMatchCount
                ? ` (${liveMatchCount})`
                : ''}`,
            className: "liveTab"
          }, {
            href: "/football/live/filter/up-next",
            text: "Up Next",
            className: "upNextTab"
          }, {
            href: "/football/live/filter/finished",
            text: "Finished",
            className: "finishedTab"
          }
        ]}/>
        <FootballMyScores hideIfEmpty={filter == 'finished'} matchList={filteredMatches}/>
        { filteredMatches.length > 0 ?
            <FootballLiveCompetitionList matchList={filteredMatches}/>
          :
            <div className="football-live-filter-no-match-msg">
              <p>{MATCH_FILTER_EMPTY_MESSAGE[filter]}</p>
            </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Football/containers/FootballLiveHomeTabs.js